import ConfirmOtp from '@fhs-legacy/frontend/src/pages/authentication/confirm-otp';
export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default ConfirmOtp;
